<template>
  <div class="common-setting">
    <div class="content-header">
      <div class="left">通用设置</div>
      <!-- <div class="right">
        <Button @click="back()" style="margin-right: 20px">取消</Button>
        <Button type="primary" @click="save()">保存</Button>
      </div> -->
      <div class="bottom"></div>
    </div>
    <div class="pageTitle">订单交易</div>
    <Form label-colon :model="data" :label-width="160">
      <FormItem label="订单自动关闭时间">
        <span>{{data.close_order_time_str}}</span>
        <span class="setting" @click="modalOff.visible = true">设置</span>
        <div class="tips">
          设置后客户未在此时间内付款，待付款订单将自动关闭，状态由待付款变为已关闭
        </div>
      </FormItem>

      <FormItem label="拼团自动成团时间">
        <span>{{data.group_success_time}}小时</span>
        <span class="setting" @click="modalGroup.visible = true">设置</span>
        <div class="tips">
          设置后团购订单未在此时间内拼团成功，该订单将自动成团
        </div>
      </FormItem>

      <FormItem label="交易提供发票">
        <i-switch v-model="data.is_invoice" :true-value='1' :false-value='0' @on-change='setInvoiceOff' />
        <span class="setting" @click="modalInvoice.visible = true">设置</span>
        <div class="tips">
          <span v-if="!data.is_invoice">开启后客户下单时可申请发票。</span>
          <span v-else
            >开启后客户下单时可申请发票。(经销商身份的客户请至个人中心申请和管理发票)</span
          >
          <Poptip trigger="hover" placement="right">
            <span class="a">查看示例</span>
            <div class="dialog" slot="content">
              <img src="../../../assets/images/dialog_classify.png" />
            </div>
          </Poptip>
        </div>
      </FormItem>
      <div class="pageTitle">发货物流</div>
      <FormItem label="买家修改收货地址">
        <i-switch v-model="data.modify_order_address" :true-value='1' :false-value='0' @on-change='setAddressOff'/>
        <div class="tips">开启后，客户可以修改待发货订单的收货地址</div>
      </FormItem>
      <FormItem label="自动确认收货时间">
        <span>{{data.receiving_goods}}天</span>
        <span class="setting" @click="modalReceiving.visible = true">设置</span>
        <div class="tips">如果客户未在该时间内确认收货，系统将自动确认收货</div>
      </FormItem>
      <FormItem label="商家地址库设置">
        <div class="shop_address_box">
          <span v-if="shopAddress.length == 0">未指定默认地址</span>
          <div v-else class="left">
            <div v-for="(item, index) in shopAddress" :key="index">
              (默认:{{
                addressType[item.type] +
                ") " +
                item.province +
                item.area +
                item.city +
                item.address +
                " " +
                item.name +
                " " +
                item.phone
              }}
            </div>
          </div>
          <span class="setting" @click="modalAddress.status = true">设置</span>
        </div>
        <div class="tips">
          设置默认退货退票地址，客户申请退货与退票，若您超时未及时处理将通知客户把货物退回至该地址，避免资金流失
        </div>
      </FormItem>
      <FormItem label="偏远地区" prop="taxpayer_code">
        <span v-if="remote_city.length == 0">未添加</span>
        <Tag
          v-else
          v-for="(item, index) in remote_city"
          :key="index"
          closable
          @on-close="handleAreaClose(index)"
          >{{ item }}</Tag
        >

        <span class="setting" @click="setRemoteArea">设置</span>
        <div class="tips">在商品档案中，可单独为偏远地区指定运输费用</div>
      </FormItem>
    </Form>

    <Modal v-model="modalOff.visible" :title="modalOff.title" width="400">
      <InputNumber
        :max="72"
        :min="0"
        v-model="modalOff.data.hour"
      ></InputNumber>
      <span style="margin: 0 10px">小时</span>
      <InputNumber
        :max="60"
        v-model="modalOff.data.minute"
      ></InputNumber>
      <span style="margin: 0 10px">分钟</span>
      <div slot="footer">
        <Button @click="modalOff.visible = false">取消</Button>
        <Button type="primary" @click="saveOrderOff">确认</Button>
      </div>
    </Modal>

    <Modal
      v-model="modalGroup.visible"
      :title="modalGroup.title"
      width="400"
    >
      <InputNumber :min="1" :max="24" v-model="modalGroup.data.hour"></InputNumber>
      <span style="margin: 0 10px">小时</span>

      <div slot="footer">
        <Button @click="modalGroup.visible = false">取消</Button>
        <Button type="primary" @click="saveGroupSuccessTime">确认</Button>
      </div>
    </Modal>


    <Modal
      v-model="modalReceiving.visible"
      :title="modalReceiving.title"
      width="400"
    >
      <InputNumber :min="1" v-model="modalReceiving.data.day"></InputNumber>
      <span style="margin: 0 10px">天</span>

      <div slot="footer">
        <Button @click="modalReceiving.visible = false">取消</Button>
        <Button type="primary" @click="saveOrderConfrim">确认</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalInvoice.visible"
      :title="modalInvoice.title"
      width="400"
      class="modal-invoice"
    >
      <Checkbox v-model="modalInvoice.data.invoice1">电子发票</Checkbox>
      <div class="item">
        <Checkbox v-model="modalInvoice.data.invoice2">纸质发票</Checkbox>
      </div>
      <div class="item">
        <Checkbox
          :value="modalInvoice.checkAll"
          :indeterminate="modalInvoice.indeterminate"
          @click.prevent.native="handleCheckAll"
          >增值税专用发票:</Checkbox
        >
        <CheckboxGroup
          v-model="modalInvoice.data.invoice3"
          class="cbg"
          @on-change="checkAllGroupChange"
        >
          <Checkbox label="会员"></Checkbox>
          <Checkbox label="经销商"></Checkbox>
        </CheckboxGroup>
      </div>
      <div slot="footer">
        <Button @click="modalInvoice.visible = false">取消</Button>
        <Button type="primary" @click="saveInvoice">确认</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalAddress.status"
      title="收货地址"
      width="1000"
      footer-hide
      @on-cancel='cancelModalAddress'
    >
      <customer-Address />
    </Modal>
    <Modal v-model="modalArea.visible" :title="modalArea.title" width="550">
      <Form ref="form" :model="data" :label-width="120" label-colon>
        <FormItem label="偏远地区" prop="taxpayer_code">
          <Select
            v-model="modalArea.data.area"
            filterable
            multiple
            style="width: 320px"
          >
            <Option
              v-for="item in area"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="modalArea.visible = false">取消</Button>
        <Button type="primary" @click="saveArea">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import areaData from "../../../libs/city.data";
import customerAddress from "./address/index";
import { mapActions, mapGetters } from "vuex";
const addressType = {
  1: "退货地址",
  2: "收票地址",
  3: "发货地址",
};
export default {
  components: {
    customerAddress,
  },
  data() {
    return {
      addressType,
      data: {
        close_order_time:'',
        is_invoice: false,
        modify_order_address: false,
        receiving_goods: "",
        group_success_time:''
      },
      area: areaData,
      modalOff: {
        visible: false,
        title: "订单自动关闭时间设置",
        data: {
          hour: 0,
          minute: 60,
        },
      },
      modalGroup: {
        visible: false,
        title: "自动成团时间设置",
        data: {
          hour: 12,
        },
      },
      modalReceiving: {
        visible: false,
        title: "自动确认收货时间设置",
        data: {
          day: 0,
        },
      },
      modalArea: {
        visible: false,
        title: "添加偏远地区",
        data: {
          area: [],
        },
      },
      modalInvoice: {
        visible: false,
        title: "发票设置",
        indeterminate: false,
        checkAll: false,
        data: {
          invoice1: false,
          invoice2: false,
          invoice3: [],
        },
      },
      modalAddress: {
        status: false,
        UserId: 0,
      },
      shopAddress: [], //商家地址库数据
      remote_city:[]
    };
  },
  mounted() {
    this.modalAddress.UserId = this.current_user.user_id;
    this.getData();
  },
  methods: {
    ...mapActions([
      "GetShopInfo",
      "PutShopInfo",
      "GetShopSetting",
      "SaveShopSetting",
      "GetShopAddress",
    ]),
    getData(){
      this.GetShopInfo().then((res) => {
          let data = res.data;
          this.remote_city = data.remote_city.split(',')
      });
      this.GetShopSetting().then((res) => {
          this.data = res.data;
          let minutes = res.data.close_order_time
          this.data.close_order_time_str = Math.floor(minutes/60)+'小时'+(minutes%60)+'分'
          this.modalOff.data.hour =  Math.floor(minutes/60)
          this.modalOff.data.minute =  minutes%60
          this.modalReceiving.data.day = res.data.receiving_goods
          this.modalGroup.data.hour = res.data.group_success_time;
      });
      this.GetShopAddress().then(res=>{
        this.shopAddress = []
        res.data.map((item) => {
          if (item.is_default == 1) {
            this.shopAddress.push(item);
          }
        });
      })
    },
    //保存订单自动关闭时间设置
    saveOrderOff() {
      let data = {};
      data.close_order_time = this.modalOff.data.hour*60+this.modalOff.data.minute;
      if(data.close_order_time<10){
        this.$Message["error"]('订单自动关闭时间不能低于10分钟');
        return;
      }
      if(data.close_order_time>4320){
        this.$Message["error"]('订单自动关闭时间不能超过72小时');
        return;
      }
      this.SaveShopSetting(data).then((res) => {
        this.modalOff.visible = false;

        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) return false;
        this.getData();
      });
    },
    //设置是否提供发票开关
    setInvoiceOff(){
      let data = {};
      if(this.data.is_invoice == 1){
        this.modalInvoice.visible = true;
      }else{
        data.is_invoice = this.data.is_invoice;
        this.SaveShopSetting(data).then((res) => {
          this.$Message[res.status ? "success" : "error"](res.msg);
          if (!res.status) return false;
        });
      }
    },
    //设置是否买家修改收货地址开关
    setAddressOff(){
      let data = {};
      data.modify_order_address = this.data.modify_order_address;
      this.SaveShopSetting(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) return false;
      });
    },
     //保存自动成团时间
    saveGroupSuccessTime(){
      let data = {};
      data.group_success_time = this.modalGroup.data.hour;
      this.SaveShopSetting(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) return false;
        this.modalGroup.visible = false;
        this.getData();
      });
    },
    //保存自动确认收货时间设置
    saveOrderConfrim() {
      let data = {};
      data.receiving_goods = this.modalReceiving.data.day;
      if(data.receiving_goods<7 || data.receiving_goods>30){
        this.$Message["error"]('自动确认收货时间只能大于7天小于30天');
        return;
      }
      this.SaveShopSetting(data).then((res) => {
        this.modalReceiving.visible = false;
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) return false;
        this.getData();
      });
    },

    handleCheckAll() {
      if (this.modalInvoice.indeterminate) {
        this.modalInvoice.checkAll = false;
      } else {
        this.modalInvoice.checkAll = !this.modalInvoice.checkAll;
      }
      this.modalInvoice.indeterminate = false;
      if (this.modalInvoice.checkAll) {
        this.modalInvoice.data.invoice3 = ["会员", "经销商"];
      } else {
        this.modalInvoice.data.invoice3 = [];
      }
    },
    checkAllGroupChange(data) {
      if (data.length === 2) {
        this.modalInvoice.indeterminate = false;
        this.modalInvoice.checkAll = true;
      } else if (data.length > 0) {
        this.modalInvoice.indeterminate = true;
        this.modalInvoice.checkAll = false;
      } else {
        this.modalInvoice.indeterminate = false;
        this.modalInvoice.checkAll = false;
      }
    },
    //单项移除偏远地区
    handleAreaClose(index) {
      this.remote_city.splice(index, 1);
      this.PutShopInfo({remote_city:this.remote_city}).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
      });
    },
    //保存发票设置
    saveInvoice() {

    },
    setRemoteArea(){
      this.modalArea.visible = true;
      this.modalArea.data.area =  this.remote_city
    },
    //保存偏远地区
    saveArea() {
      let data = {};
      data.remote_city = this.modalArea.data.area.join(",");
      this.PutShopInfo(data).then((res) => {
        this.modalArea.visible = false;
        this.$Message[res.status ? "success" : "error"](res.msg);
        // if (!res.status) return false;
        this.getData();
      });
    },
    cancelModalAddress(){
       this.GetShopInfo().then((res) => {
          let data = res.data;
          this.remote_city = data.remote_city.split(',')
      });
    }
  },

  computed: mapGetters({
    current_user: "current_user",
  }),
};
</script>

<style lang="less">
@import "./index.less";
</style>
